import "./styles/_golf-banner.scss";
import { isScriptFullyLoaded, markScriptFullyLoaded, onDocumentReady } from "../utils/dom";

const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.01,
};

const state = {
    components:  [],
}

function cacheState() {
    const sections = Array.from(document.querySelectorAll('.Golf-banner'));
    state.components = getComponents(sections)
}

function attachEventListeners() {
    window.addEventListener("resize", setVideoBackground);
    state.components.forEach(component => {
        component.btns.forEach(btn => {
            btn.addEventListener('click', onControlClick.bind(component))
        })
    })
}

function getComponents(sections) {
    if (!Array.isArray(sections)) return [];

    return sections.reduce((acc, curr) => {
        const videoEl = curr.querySelector("video.Golf-banner__media");
        if (!videoEl) return acc;
        
        const currentComponent = {
            videoEl,
            btns: Array.from(curr.querySelectorAll(".Golf-banner__media-control [data-state]")),
            wasAudioMuted: true,
            wasPlaying: true,
        }
        return [currentComponent, ...acc]
    }, [])
}

function setVideoBackground() {
    const isMobile = window.matchMedia('(max-width: 600px)').matches;
    state.components.forEach(component => {
        const { videoEl } = component;
        if (!videoEl) return;
        const currentSrc = videoEl.src;
        const newSrc = isMobile ? videoEl.dataset.srcMobile : videoEl.dataset.srcDesktop;
        if (currentSrc === newSrc) return;

        videoEl.src = newSrc;
    })
}

function getAction(currentTarget) {
    const { type, state } = currentTarget.dataset
    const actionRoute = {
        video: {
            playing: {
                type,
                state: "paused",
                action: "pause"
            },
            paused: {
                type,
                state: "playing",
                action: "play"
            }
        },
        audio: {
            muted: {
                type,
                state: "unmuted",
                action: false
            },
            unmuted: {
                type,
                state: "muted",
                action: true
            },
        }
    }
    return actionRoute?.[type]?.[state]
}

function onControlClick(e) {
    const { currentTarget } = e;
    const actionObj = getAction(currentTarget);

    currentTarget.dataset.state = actionObj.state;
    if (actionObj.type === "audio") {
        this.videoEl.muted = actionObj.action
    } else {
        this.videoEl?.[actionObj.action]?.();
    }
}

function attachIntersectionObserver() {
    state.components.forEach(component => {
        const { videoEl, btns } = component;
        if (!videoEl) return;

        const observer = new IntersectionObserver((e) => {
            if (!e[0].isIntersecting) {
                component.wasPlaying = !videoEl.paused;
                component.wasAudioMuted = videoEl.muted;

                videoEl.pause();
                btns.forEach(btn => {
                    const actionObj = getAction(btn);
                    if (actionObj.type !== "audio") {
                        btn.dataset.state = "paused";
                    }
                });
                return;
            }

            videoEl.muted = component.wasAudioMuted;
            if (!component.wasPlaying) return;
    
            videoEl.play();
            btns.forEach(btn => {
                const actionObj = getAction(btn);
                if (actionObj.type !== "audio") {
                    btn.dataset.state = "playing";
                }
            });
            
        }, options);
        observer.observe(videoEl);
    })
}

function init() {
    const isLoadedBefore = isScriptFullyLoaded("golf-banner");
    if (isLoadedBefore) return;
    markScriptFullyLoaded("golf-banner");

    cacheState();
    attachEventListeners();
    setVideoBackground();
    attachIntersectionObserver();
}

onDocumentReady(init)

